<template>
  <div class="notice-block">
    <GwMessage
      :message="{
        hide: true,
        icon: 'mdi-progress-alert',
        type: 'error',
        text: $t(`tooltips.status_warning_${warningStatus}`),
      }"
      style="--clr-back: #23b5ef"
      class="w-100"
    >
    </GwMessage>
  </div>
</template>

<script>
import GwMessage from '@/components/Messages/GwMessage'

export default {
  name: 'PartiallyAnalyzedHand',
  components: {
    GwMessage,
  },
  props: {
    warningStatus: String,
  },
}
</script>
<style lang="scss" scoped>
.notice-block {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
